import { render, staticRenderFns } from "./Spare.vue?vue&type=template&id=00545619&scoped=true"
import script from "./Spare.vue?vue&type=script&lang=js"
export * from "./Spare.vue?vue&type=script&lang=js"
import style0 from "./Spare.vue?vue&type=style&index=0&id=00545619&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00545619",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00545619')) {
      api.createRecord('00545619', component.options)
    } else {
      api.reload('00545619', component.options)
    }
    module.hot.accept("./Spare.vue?vue&type=template&id=00545619&scoped=true", function () {
      api.rerender('00545619', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Before/ProjectInfo/Spare.vue"
export default component.exports